/******/ (() => { // webpackBootstrap
/*!*******************************!*\
  !*** ./src/scripts/common.js ***!
  \*******************************/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
window.addEventListener("DOMContentLoaded", function () {
  var bodyHtml = document.body;
  var jsMarqueeSwiper = document.querySelectorAll('.js-marquee-swiper');
  if (jsMarqueeSwiper.length) {
    jsMarqueeSwiper.forEach(function (marqueeSwiper) {
      var jsMarqueeSwiperInit = new Swiper(marqueeSwiper, {
        spaceBetween: 0,
        centeredSlides: true,
        speed: 6000,
        autoplay: {
          delay: 10,
          disableOnInteraction: true
        },
        loop: true,
        slidesPerView: 'auto',
        allowTouchMove: false
      });
      window.addEventListener('resize', function () {
        if (jsMarqueeSwiperInit) {
          jsMarqueeSwiperInit.update();
        }
      });
    });
  }
  var jsMarqueeTextSwiper = document.querySelectorAll('.js-marquee-swiper-text');
  if (jsMarqueeTextSwiper.length) {
    jsMarqueeTextSwiper.forEach(function (marqueeSwiperText) {
      var jsMarqueeTextSwiperInit = new Swiper(marqueeSwiperText, {
        spaceBetween: 0,
        centeredSlides: true,
        speed: 4000,
        autoplay: {
          delay: 10,
          disableOnInteraction: true
        },
        loop: true,
        slidesPerView: 'auto',
        loopAdditionalSlides: 2,
        allowTouchMove: false
      });
      window.addEventListener('resize', function () {
        if (jsMarqueeTextSwiperInit) {
          jsMarqueeTextSwiperInit.update();
        }
      });
    });
  }
  var jsIngredientsSwiper = document.querySelectorAll('.js-ingredients-swiper');
  if (jsIngredientsSwiper.length) {
    var jsIngredientsPrev = document.querySelector('.js-ingredients-prev');
    var jsIngredientsNext = document.querySelector('.js-ingredients-next');
    jsIngredientsSwiper.forEach(function (ingredient) {
      var jsIngredientsSwiperInit = new Swiper(ingredient, {
        spaceBetween: 20,
        loop: false,
        slidesPerView: 2,
        navigation: {
          prevEl: jsIngredientsPrev,
          nextEl: jsIngredientsNext
        },
        breakpoints: {
          320: {
            spaceBetween: 10,
            slidesPerView: 1.05
          },
          767: {
            spaceBetween: 20,
            slidesPerView: 2
          }
        }
      });
    });
  }

var swiperMain;
var swiperThumbs;
function initializeSwiper() { 
  // Thumbs
  swiperThumbs = new Swiper('.js-swiper-picture-thumbs', {
    slidesPerView: 5,
    spaceBetween: 18,
    watchSlidesProgress: true, 
  });
  // Main
  swiperMain = new Swiper('.js-swiper-picture-main', {
    spaceBetween: 18,
    thumbs: {
      swiper: swiperThumbs,
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
    },
  }); 
}
function destroySwiper() {
  if (swiperMain) {
    swiperMain.destroy(true, true);
    swiperMain = null;
  } 
  if (swiperThumbs)
  { swiperThumbs.destroy(true, true);
    swiperThumbs = null;
  }
}
function reinitSwiper() {
  destroySwiper();
  initializeSwiper();
}
window.addEventListener('resize', function () {
  reinitSwiper();
});

initializeSwiper();

  
  var jsCollectionSwiper = document.querySelectorAll('.js-collection-swiper');
  if (jsCollectionSwiper.length) {
    jsCollectionSwiper.forEach(function (collection) {
      var jsCollectionSwiperInit = new Swiper(collection, {
        spaceBetween: 20,
        loop: true,
        slidesPerView: 3,
        grabCursor: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: true
        },
        breakpoints: {
          320: {
            spaceBetween: 10,
            slidesPerView: 1
          },
          767: {
            spaceBetween: 20,
            slidesPerView: 3
          }
        }
      });
    });
  }

  /**
   * STICKY-HEADER
   */
  var header = document.querySelector('.heade-sticky'),
    scrollPrev = 0;
  window.addEventListener('scroll', function () {
    var scrolled = document.documentElement.scrollTop;
    if (scrolled >= 50 && scrolled > scrollPrev) {
      header.classList.add('out');
      header.classList.add('fixed');
    } else if (scrolled < 50) {
      header.classList.remove('fixed');
      header.classList.remove('out');
    } else {
      header.classList.remove('out');
    }
    scrollPrev = scrolled;
  });

  /**
   * accordion
   */
  var accButtons = document.querySelectorAll('.js-accordion-header');
  if (accButtons.length) {
    accButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = this.parentElement;
        // Close all other items if you need collapse
        accButtons.forEach(function (button) {
          var otherItem = button.parentElement;
          if (otherItem !== item) {
            otherItem.classList.remove('active');
          }
        });
        // Toggle the current item
        item.classList.toggle('active');
      });
    });
  }

  /**
   * search react
   */
  var jsCounterIngr = document.querySelector('.js-count-ingr');
  var jsRecord = document.querySelectorAll('.js-record');
  if (jsCounterIngr && jsRecord.length) {
    jsCounterIngr.innerText = jsRecord.length;
  }
  var searchInput = document.getElementById('search-input');
  if (searchInput) {
    document.getElementById('search-input').addEventListener('input', function () {
      var searchTerm = this.value.toLowerCase();
      var records = document.querySelectorAll('.js-record');
      records.forEach(function (record) {
        var name = record.dataset.name.toLowerCase();
        if (name.includes(searchTerm)) {
          record.style.display = '';
        } else {
          record.style.display = 'none';
        }
      });
    });
  }

  /**
   * menu mobile
   */
  var menuButton = document.querySelector('.js-button-menu');
  if (menuButton) {
    menuButton.addEventListener('click', function (e) {
      e.preventDefault();
      bodyHtml.classList.toggle('menu-open');
    });
  }
  var headerNav = document.querySelector('.header__nav');
  if (headerNav) {
    headerNav.addEventListener('mouseenter', function (event) {
      document.querySelector('.header').classList.add('add-bg');
    });
    headerNav.addEventListener('mouseleave', function (event) {
      document.querySelector('.header').classList.remove('add-bg');
    });
  }

  /**
   * JS modal cart
   */
  var removeButtonProduct;
  var jsOpenCart = document.querySelectorAll('.js-open-cart');
  if (jsOpenCart.length) {
    jsOpenCart.forEach(function (buttonOpenCart) {
      buttonOpenCart.addEventListener('click', function (event) {
        event.preventDefault();
        bodyHtml.classList.add('js-view-cart');
        removeButtonProduct = document.querySelectorAll('.remove-button');
        addRemoveButtonListeners();
      });
    });
  }
  document.body.addEventListener('click', function (event) {
    if (event.target.classList.contains('js-close-card')) {
      event.preventDefault();
      bodyHtml.classList.remove('js-view-cart');
      bodyHtml.classList.remove('js-view-size');
    }
  });
  var jsProductCart = document.querySelectorAll('.product-cart');
  if (jsProductCart) {
    jsProductCart.forEach(function (jscart) {
      setTimeout(function () {
        jscart.style.display = 'block';
      }, 500);
    });
  }
  function updateCartDrawer() {
    return _updateCartDrawer.apply(this, arguments);
  }
  function _updateCartDrawer() {
    _updateCartDrawer = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var res, text, html, newBox;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return fetch("/?section_id=product-cart");
          case 2:
            res = _context5.sent;
            _context5.next = 5;
            return res.text();
          case 5:
            text = _context5.sent;
            html = document.createElement("div");
            html.innerHTML = text;
            newBox = html.querySelector(".product-cart").innerHTML;
            document.querySelector(".product-cart").innerHTML = newBox;
            removeButtonProduct = document.querySelectorAll('.remove-button');
            addRemoveButtonListeners();
          case 12:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return _updateCartDrawer.apply(this, arguments);
  }
  function addRemoveButtonListeners() {
    removeButtonProduct.forEach(function (button) {
      button.addEventListener('click', /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
          var dataIndex, response, rescart, cart;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                event.preventDefault();
                dataIndex = button.dataset.variant;
                _context.prev = 2;
                showLoader();
                _context.next = 6;
                return fetch(window.Shopify.routes.root + 'cart/change.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                    id: dataIndex,
                    quantity: 0
                  })
                });
              case 6:
                response = _context.sent;
                _context.next = 9;
                return fetch(window.Shopify.routes.root + "cart.js");
              case 9:
                rescart = _context.sent;
                _context.next = 12;
                return rescart.json();
              case 12:
                cart = _context.sent;
                updateCartItemCounts(cart.item_count);
                if (response.ok) {
                  updateCartDrawer();
                } else {
                  console.error('error response:', response.status);
                }
                _context.next = 20;
                break;
              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](2);
                console.error('error catch:', _context.t0);
              case 20:
                _context.prev = 20;
                hideLoader();
                return _context.finish(20);
              case 23:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[2, 17, 20, 23]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    });
  }
  function showLoader() {
    var loader = document.querySelector('.js-loader');
    loader.style.display = 'flex';
  }
  function hideLoader() {
    var loader = document.querySelector('.js-loader');
    setTimeout(function () {
      loader.style.display = 'none';
    }, 1000);
  }
  function updateCartItemCounts(count) {
    document.querySelectorAll(".js-cart-count").forEach(function (el) {
      el.textContent = count;
    });
  }
  var jsSelectVariant = document.querySelectorAll('.js-select-variant');
  var jsHiddenVariant = document.querySelectorAll('form input[name="id"]');
  var currentVariant;
  if (jsSelectVariant.length) {
    jsSelectVariant.forEach(function (currentSelect) {
      currentSelect.addEventListener('change', function (event) {
        setTimeout(function () {
          var currentUrl = window.location.href;
          var urlParts = currentUrl.split('?');
          if (urlParts.length > 1) {
            var queryParams = urlParts[1].split('&');
            var _iterator = _createForOfIteratorHelper(queryParams),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var param = _step.value;
                var _param$split = param.split('='),
                  _param$split2 = _slicedToArray(_param$split, 2),
                  key = _param$split2[0],
                  value = _param$split2[1];
                if (key === 'variant') {
                  currentVariant = value;
                  break;
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          } else {
            console.log('varient none');
          }
          jsHiddenVariant.forEach(function (currentValue) {
            currentValue.setAttribute('value', currentVariant);
          });
        }, 100);
      });
    });
  }

  /**
   * JS cart drawer
   */
  function updateCartDrawer() {
    return _updateCartDrawer2.apply(this, arguments);
  }
  function _updateCartDrawer2() {
    _updateCartDrawer2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      var res, text, html, newBox;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return fetch("/?section_id=product-cart");
          case 2:
            res = _context6.sent;
            _context6.next = 5;
            return res.text();
          case 5:
            text = _context6.sent;
            html = document.createElement("div");
            html.innerHTML = text;
            newBox = html.querySelector(".js-modal-cart").innerHTML;
            document.querySelector(".js-modal-cart").innerHTML = newBox;
            removeButtonProduct = document.querySelectorAll('.remove-button');
            addRemoveButtonListeners();
            addCartDrawerListeners();
          case 13:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return _updateCartDrawer2.apply(this, arguments);
  }
  var timeoutAdd;
  function addCartDrawerListeners() {
    // Update quantities
    document.querySelectorAll(".cart-drawer-quantity-selector button").forEach(function (button) {
      button.addEventListener("click", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var rootItem, key, currentInput, currentQuantity, isUp, newQuantity;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              clearTimeout(timeoutAdd);
              // Get line item key
              rootItem = button.parentElement.parentElement.parentElement.parentElement;
              key = rootItem.getAttribute("data-line-item-key");
              console.log(key);
              currentInput = button.parentElement.querySelector("input");
              currentQuantity = Number(currentInput.value);
              isUp = button.classList.contains("cart-drawer-quantity-selector-plus");
              newQuantity = currentQuantity;
              if (isUp) {
                newQuantity = currentQuantity + 1;
              } else {
                newQuantity = Math.max(currentQuantity - 1, 0);
              }
              currentInput.value = newQuantity;
              timeoutAdd = setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                var res, cart;
                return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.prev = 0;
                      showLoader();

                      // Ajax update\
                      _context2.next = 4;
                      return fetch("/cart/update.js", {
                        method: "post",
                        headers: {
                          Accept: "application/json",
                          "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                          updates: _defineProperty({}, key, newQuantity)
                        })
                      });
                    case 4:
                      res = _context2.sent;
                      _context2.next = 7;
                      return res.json();
                    case 7:
                      cart = _context2.sent;
                      updateCartItemCounts(cart.item_count);

                      // Update cart
                      updateCartDrawer();
                      _context2.next = 15;
                      break;
                    case 12:
                      _context2.prev = 12;
                      _context2.t0 = _context2["catch"](0);
                      console.error('error add to cart catch:', _context2.t0);
                    case 15:
                      _context2.prev = 15;
                      hideLoader();
                      return _context2.finish(15);
                    case 18:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2, null, [[0, 12, 15, 18]]);
              })), 300);
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      })));
    });
  }
  addCartDrawerListeners();
  var products = [];
  var addToCartForm = document.querySelectorAll('form[action$="/cart/add"]');
  if (addToCartForm.length) {
    addToCartForm.forEach(function (addForm) {
      addForm.addEventListener('submit', /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(event) {
          var formData, response, rescart, cart;
          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                event.preventDefault();
                formData = new FormData(addForm);
                _context4.prev = 2;
                showLoader();
                console.log('show');
                _context4.next = 7;
                return fetch(window.Shopify.routes.root + 'cart/add.js', {
                  method: 'POST',
                  body: formData
                });
              case 7:
                response = _context4.sent;
                _context4.next = 10;
                return fetch(window.Shopify.routes.root + "cart.js");
              case 10:
                rescart = _context4.sent;
                _context4.next = 13;
                return rescart.json();
              case 13:
                cart = _context4.sent;
                updateCartItemCounts(cart.item_count);
                if (response.ok) {
                  updateCartDrawer();
                  bodyHtml.classList.add('js-view-cart');
                } else {
                  console.error('error add to cart:', response.status);
                }
                _context4.next = 21;
                break;
              case 18:
                _context4.prev = 18;
                _context4.t0 = _context4["catch"](2);
                console.error('error add to cart catch:', _context4.t0);
              case 21:
                _context4.prev = 21;
                hideLoader();
                return _context4.finish(21);
              case 24:
              case "end":
                return _context4.stop();
            }
          }, _callee4, null, [[2, 18, 21, 24]]);
        }));
        return function (_x2) {
          return _ref4.apply(this, arguments);
        };
      }());
    });
  }
});

//If you really need Jquery
/*
$(document).ready(function(){

})
 */
/******/ })()
;